/**
 * Open a file fetched with the sign-in header (a PDF) in a new tab — an
 * expense's invoice (G-135) and a delivery's document (G-137). The tab is
 * opened at once, inside the click: browsers block a window opened after an
 * await. It is pointed at the blob when it arrives (a link click when the
 * browser refused the tab), and the blob URL is revoked a minute later.
 * Throws, after closing the tab, when the fetch fails or returns nothing.
 */
export async function openBlobInNewTab(fetchUrl: () => Promise<string | null>): Promise<void> {
  const tab = window.open("", "_blank");
  let url: string | null;
  try {
    url = await fetchUrl();
  } catch (err) {
    tab?.close();
    throw err;
  }
  if (!url) {
    tab?.close();
    throw new Error("Could not open the file.");
  }
  if (tab) {
    tab.location.href = url;
  } else {
    const link = document.createElement("a");
    link.href = url;
    link.target = "_blank";
    link.click();
  }
  const opened = url;
  window.setTimeout(() => URL.revokeObjectURL(opened), 60_000);
}
